"use client";

import { Button } from "@/components/ui/button";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useDebouncedCallback } from "use-debounce";
export default function ThemeToggle() {
  const {
    resolvedTheme,
    setTheme
  } = useTheme();
  const toggleTheme = useDebouncedCallback(() => {
    if (typeof resolvedTheme === "undefined") return;
    try {
      setTheme(resolvedTheme === "dark" ? "light" : "dark");
    } catch (error) {
      console.error("Failed to toggle theme:", error);
    }
  }, 50);
  return <Button onClick={toggleTheme} size="icon" variant="outline">
      <Sun className="size-4 scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
      <Moon className="absolute size-4 scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
      <span className="sr-only">Cambiar tema</span>
    </Button>;
}